import React from 'react';
import './UserCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function UserCard({ user }) {
  const userName = `${user.legalFirstName} ${user.lastName}`;
  if (logComponent('UserCard')) { console.debug('UserCard rendered'); }

  return (
    <div className="User-Card">
      <p className="User-Card__name">{userName}</p>
      <p className="User-Card__email" title={user.emailAddress}>{user.emailAddress}</p>
      {
        user.canCorrespond &&
        <p className="User-Card__correspondence">
          <FontAwesomeIcon className="User-Card__icon" icon="comment" />
          Correspondence override enabled
        </p>
      }
      {
        user.canImpersonate &&
        <p className="User-Card__impersonate">
          <FontAwesomeIcon className="User-Card__icon" icon="eye" />
          Mimic override enabled
        </p>
      }
    </div>
  )
}